import { useState } from "react";
import SubmitButton from "../../buttons";
import { LoginState, useLogin } from "../context";
import { LoadingSpinner } from "../../loading";
import "../../FormComponent/forms.scss";
import { TextInput } from "../../forms/TextInput";

export const MagicLink = () => {
  const { loginState } = useLogin();

  if (loginState == LoginState.MAGICLINK) {
    return <SendMagicLink />;
  } else if (loginState == LoginState.MAGICLINKSENT) return <MagicLinkSent />;

  return <></>;
};

const SendMagicLink = () => {
  const { sendMagicLink, submitting, error } = useLogin();
  const [email, setEmail] = useState("");

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();

        sendMagicLink(email);
      }}
    >
      <h1 className={"nhsuk-u-font-size-32"} style={{ marginBottom: "16px" }}>
        Login
      </h1>

      <p className={"nhsuk-u-font-size-19"}>
        To access this service, please enter your email address and we will
        email you a one time access link. Click on the link within this email to
        access the system.
      </p>
      <>
        <TextInput
          label={"Email Address"}
          inputWidth={"500px"}
          id={"email"}
          enabled={true}
          onChange={(e: any) => setEmail(e.target.value)}
        />

        {submitting && <LoadingSpinner />}
        {!submitting && (
          <SubmitButton
            content={<>Email access link</>}
            style={{ marginLeft: 0 }}
          />
        )}
        {error && <p style={{ color: "red" }}>{error}</p>}
      </>

      <p className={"nhsuk-u-font-size-14"}>
        If you don't receive promptly, please check your spam/junk folder.
      </p>
    </form>
  );
};

const MagicLinkSent = () => {
  return (
    <>
      <h1 className={"nhsuk-u-font-size-32"} style={{ marginBottom: "16px" }}>
        Login
      </h1>

      <p className={"nhsuk-u-font-size-19"}>
        If your email address has been matched to an account, you will shortly
        receive a link to access.
        <br />
        Please check your inbox.
      </p>

      <p className={"nhsuk-u-font-size-16"}>
        If you have not received an email, please check your spam/junk folder.
      </p>
    </>
  );
};
